module.exports = __webpack_public_path__ + "static/media/domany-funtan.f7034e33.jpg";